import { safeLocalStorageGet, safeLocalStorageSet, safeRandomId } from "@/lib/safe-browser";

const KEY = "routify_anon_id";

export function getAnonId(): string {
  if (typeof window === "undefined") return "";
  try {
    let id = safeLocalStorageGet(KEY);
    if (!id) {
      id = safeRandomId("anon");
      safeLocalStorageSet(KEY, id);
    }
    return id;
  } catch {
    return "";
  }
}
